import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

interface TWNavbarProps {
  onCtaClick: () => void;
}

export default function TWNavbar({ onCtaClick }: TWNavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white/95 backdrop-blur-md border-b border-zinc-100 py-3 shadow-sm' : 'bg-transparent py-5'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        <a
          href="/"
          onClick={(e) => { e.preventDefault(); navigate('/'); }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <div className="w-8 h-8 flex items-center justify-center bg-orange-500 rounded-lg">
            <i className="ri-rocket-2-fill text-white text-sm" />
          </div>
          <span className={`font-bold text-xl tracking-tight transition-colors duration-300 ${scrolled ? 'text-zinc-900' : 'text-white'}`}>
            boost<span className="text-orange-500">io</span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-6">
          <a
            href="/#referencie"
            onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => { const el = document.querySelector('#referencie'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 200); }}
            className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${scrolled ? 'text-zinc-600 hover:text-zinc-900' : 'text-white/80 hover:text-white'}`}
          >
            Referencie
          </a>
          <a
            href="/#cennik"
            onClick={(e) => { e.preventDefault(); navigate('/'); setTimeout(() => { const el = document.querySelector('#cennik'); if (el) el.scrollIntoView({ behavior: 'smooth' }); }, 200); }}
            className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap ${scrolled ? 'text-zinc-600 hover:text-zinc-900' : 'text-white/80 hover:text-white'}`}
          >
            Cenník
          </a>
          <button
            onClick={onCtaClick}
            className="bg-orange-500 hover:bg-orange-400 text-white text-sm font-bold px-5 py-2.5 rounded-lg transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Chcem web zadarmo konzultovať
          </button>
        </div>

        <button
          onClick={onCtaClick}
          className="md:hidden bg-orange-500 text-white text-xs font-bold px-4 py-2.5 rounded-lg cursor-pointer whitespace-nowrap"
        >
          Konzultácia zadarmo
        </button>
      </div>
    </header>
  );
}
